/**
 * RefreshButton — reusable refresh icon for widget headers. Matches the
 * Penpot mockup icon (rounded arrows). Hands the click off to the caller
 * so each widget can invalidate its own React Query cache.
 *
 * Reusable across any data widget. Currently used by Appointments, Invoices,
 * Aging Report, Requests By Type, Estimates, and Repair Requests in the
 * Penpot dashboard. Date-list widgets (Service Requests, Projects, Days Off)
 * don't include it.
 */

import * as React from "react";

export interface RefreshButtonProps {
  onClick?: () => void;
  ariaLabel?: string;
}

export function RefreshButton({ onClick, ariaLabel = "Refresh" }: RefreshButtonProps) {
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      onClick={onClick}
      className="text-gray-400 hover:text-gray-600 transition-colors p-1 -m-1"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <polyline points="23 4 23 10 17 10" />
        <polyline points="1 20 1 14 7 14" />
        <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
      </svg>
    </button>
  );
}
